export const getCookie = (cname) => {
	const name = `${cname}=`;
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const setCookie = (cname, cvalue) => {
	document.cookie = `${cname}=${cvalue};`;
};

// Checks if a string has at least 8 characters, both upper and lowercase letters, and a number
// Returns boolean
export const isPasswordValid = (password) => {
	let passwordValid = true;

	if (password.length < 8) {
		passwordValid = false;
	}
	if (!password.match(/[a-z]/)) {
		passwordValid = false;
	}
	if (!password.match(/[A-Z]/)) {
		passwordValid = false;
	}
	if (!password.match(/[0-9]/)) {
		passwordValid = false;
	}
	return passwordValid;
};

export const getParameterByName = (theName, theUrl) => {
	const url = theUrl || window.location.href;
	const name = theName.replace(/[\[\]]/g, "\\$&");
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) {
		return null;
	}
	if (!results[2]) {
		return "";
	}
	return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const detectBrowser = () => {
	// Opera 8.0+
	const isOpera =
		(!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

	// Firefox 1.0+
	const isFirefox = typeof InstallTrigger !== "undefined";

	// Safari 3.0+ "[object HTMLElementConstructor]"
	const isSafari =
		/constructor/i.test(window.HTMLElement) ||
		(function(p) {
			return p.toString() === "[object SafariRemoteNotification]";
		})(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));

	// Internet Explorer 6-11
	const isIE = /* @cc_on!@ */ false || !!document.documentMode;

	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;

	// Chrome 1+
	const isChrome = !!window.chrome && !!window.chrome.webstore;

	// Blink engine detection
	const isBlink = (isChrome || isOpera) && !!window.CSS;
	// return "ie";
	return isBlink
		? "blink"
		: isChrome
			? "chrome"
			: isEdge
				? "edge"
				: isIE ? "ie" : isSafari ? "safari" : isFirefox ? "firefox" : isOpera ? "opera" : undefined;
};
